import { render, staticRenderFns } from "./QuotesAndPolicies.vue?vue&type=template&id=12c27514&scoped=true&"
import script from "./QuotesAndPolicies.vue?vue&type=script&lang=js&"
export * from "./QuotesAndPolicies.vue?vue&type=script&lang=js&"
import style0 from "./QuotesAndPolicies.vue?vue&type=style&index=0&id=12c27514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c27514",
  null
  
)

export default component.exports